// 加入前缀，用于展示
export function addIpPrefixToImageSrc(html, prefixUrl) {
  // 使用正则表达式匹配所有 <img src="..."> 标签中的路径
  const regex = /(<img src=")(?!http:\/\/|https:\/\/)([^"]+)(?=")/g;

  // 替换函数：将匹配到的路径添加前缀
  return html.replace(regex, (match, p1, p2) => {
    // p1 是 <img src=" 部分，p2 是路径部分
    return p1 + prefixUrl + p2; // 将 IP 前缀加到路径前
  });
}